import { Container, Spacer, Typography } from '@cleartrip/ct-design-components'
import { useRouter } from 'next/router'
import { useEffect, useRef, useState } from 'react'

import { useAppDispatch } from '@/redux/store/hooks'

import Clevertap from '@/analytics/clevertap/index'
import { ravenSDKHomeTrigger } from '@/analytics/raven/ravenSDKHelper'
import { setRumPage, trackRumEvent, RUM_EVENT } from '@/analytics/sparkloom'
import HomeForm from '@/components/home/HomeForm'
import { ACTION_NAMES } from '@/constants/analytics'
import { SaleConfigObject } from '@/constants/components/homeConstants'
import { HOME_API_ENDPOINTS, REQUEST_METHODS } from '@/constants/network'
import useVariant from '@/hooks/statsig/useVariant'
import baseFetch from '@/network/baseFetch'
import useFetch from '@/network/useFetch'
import { ActionMapper, NavigateType } from '@/types'
import { bannerDataType, BbdJson, IBanner } from '@/types/home'
import { isServer } from '@/utils/general'
import { getActionPayload } from '@/utils/general/actions'
import { getScript, isEmpty } from '@/utils/general/browserHelper'
import { deleteCookie, getCookie } from '@/utils/general/cookie'
import { getIndianTime } from '@/utils/general/date'
import { getBannerData, getCarousalData, isFeatureEnabled, isFeatureEnabledOfferSlots } from '@/utils/general/uiHelper'
import { getApiDomain } from '@/utils/general/url'
import { isExploreFeatureEnabled } from '@/utils/explore'
import { isUserSignedIn } from '@/utils/general/user'
import useInView from '@/utils/hooks/useInView'
import { paidAffiliateTracker, paidChannelTracker } from '@/utils/pages/home'
import { getCleartripScriptOrigin } from '@/utils/general/cleartripOrigin'

import CarousalOffer from './CarousalHomePage'
import ClearChoiceMaxBannerContainer from './ClearChoiceMaxBanner'
import CookieBanner from './CookieBanner'
import { UnifiedWidgetStack } from './UnifiedWidgetStack'
import FkImages from './FKImages'
import FlightDeals from './flightDeals'
import ImageGrid from './ImageGrid'
import RecentSearch from './RecentSearch'
import ExpandWidgetAnimationWrapper from '../ExpandWidgetAnimationWrapper'
import FAQs from './SEOContent/FAQ'
import ExploreAnywhereMap from './ExploreAnywhere'
import TripSuggestor from './TripSuggestor'
import VisaDenialBanner from './VisaDenialBanner/index'
import InlineSectionErrorFallback from '@/components/shared/InlineSectionErrorFallback'
import { withErrorBoundary } from '@/components/shared/SentryErrorBoundary'
import { queryFormat } from '../oldComponents/Dropdown/HomeSearchContainer'

// import ComplianceBanner from './ComplianceBanner'
// import { getCompliancePolicyStatus } from '@/api/homepage'

interface Banner {
    format: null
}

interface Ext {
    slotid: string | undefined
}

interface MainObject {
    banner: Banner
    ext: Ext
}
const HomeMain = ({uhpCookie,data:response} : {uhpCookie : boolean | string,data:BbdJson[]}) => {
    /*
     * setting isLoaing's default value true to avoid one re-rendeer and to do client side actions after hydration.
     * so we can avoid the hydration error.
     */
    const [isLoading,setIsLoading] = useState(true)
    const [showBanner, setShowBanner] = useState(false)
    const [showVisaBanner, setShowVisaBanner] = useState(false)
    
    const [query, setQuery] = useState<queryFormat>({ adults: '1', childs: '0', infants: '0', class: 'Economy' })

    const [fkResponseImages, setFkResponseImages] = useState({})
    const [cookieBannerFlag, setCookieBanner] = useState(false)
    // const [showComplianceBanner, setShowComplianceBanner] = useState(false)

    const handleQueryChange = (newQuery: Partial<queryFormat>) => {
        setQuery(prevQuery => ({
            ...prevQuery,
            ...newQuery
        }))
    }

    let offerSlotData: BbdJson | undefined
    if (!isLoading && response) {
        offerSlotData = isFeatureEnabled(response)
    }
    
    useEffect(() =>{
        setIsLoading(false)
        setRumPage('flights_homepage')
        trackRumEvent(RUM_EVENT.HOME_LOADED, {})
    },[])
    useEffect(() => {
        if (!isLoading && response) {
            const fkTempArray: MainObject[] = []
            let dummyObject = {
                banner: {
                    format: null
                },
                ext: {
                    slotid: ''
                }
            }
            offerSlotData?.fkSlots?.map((item, key) => {
                if (!isEmpty(item?.slotId)) {
                    dummyObject = {
                        banner: {
                            format: null
                        },
                        ext: {
                            slotid: item?.slotId
                        }
                    }
                    fkTempArray.push(dummyObject)
                }
            })
            // fetchFkData(fkTempArray)
        }
    }, [isLoading, response])

    async function fetchFkData(fkTempArray: MainObject[]) {
        try {
            const SitePayload = {
                id: (Date.now() % 10000) / 10000,
                imp: fkTempArray,
                device: {
                    ua: window?.navigator?.userAgent,
                    geo: {}
                },

                site: {
                    id: '0',
                    name: 'CA_EN',
                    domain: getApiDomain()
                },
                wlang: ['en']
            }

            const response = await baseFetch<ResponseType>({
                body: JSON.stringify(SitePayload),
                url: HOME_API_ENDPOINTS.FK_ADS,
                method: REQUEST_METHODS.POST
            })

            if (response) {
                setFkResponseImages(response)
            }
        } catch (e) {
            console.log(e)
        }
    }

    const dispatcher = useAppDispatch()

    // const redirectToCfnrLandingPage = () => {
    //   ravenHomeCfnrBannerClicked();
    //   window.open('https://offers.cleartrip.com/flights-clearchoice');
    // };

    // const cfnrHomeBannerUrl = '/offermgmt/flightsCommonImages/cfnr/clearchoice-home-banner.png';
    const [offerHook, setOfferHook] = useState({})
    const offerJSON = async () => {
        const cleartripScriptOrigin = getCleartripScriptOrigin()
        await getScript(
            `${cleartripScriptOrigin}/offermgmt/offermgmt/offerJson/${
                ['staging', 'development'].includes(process.env.NEXT_PUBLIC_CT_ENV || '') ? 'staging' : 'prod'
            }/offerSlot.js?` + new Date().getTime(),
            () => {
                setOfferHook((Date.now() % 10000) / 10000) // Hack for BBD
            }
        )
    }

    useEffect(() => {
        offerJSON()
        // getComplianceStatus()
        if (window && window.localStorage && !window.localStorage.getItem('gdpr')) {
            setCookieBanner(true)
        }
        paidAffiliateTracker()
        paidChannelTracker()
        const affiliateutmExpiryDate = getCookie('affiliate_expdate')
        if (affiliateutmExpiryDate) {
            deleteCookie('affiliate_expdate')
        }
    }, [])
    const { humbgerSale, cysWidgetData, loyaltyWidgetData } = isFeatureEnabledOfferSlots()

    const { desktopCarousels, mobileBannerList, loginBannerData } = offerSlotData || {}
    let carousalData: IBanner[] = []
    let bannerData: bannerDataType = []
    if (!isLoading && mobileBannerList?.length) {
        carousalData = getCarousalData(mobileBannerList!)
        bannerData = getBannerData(mobileBannerList!)
    }

    const { variant: cysEnabledVariant } =
        useVariant({
            experiment: 'continue_your_search_uhp_and_fhp',
            cookieValue: 'cysUhpFhp',
            experimentParameter: 'cys_enabled',
            defaultVariant: 'yes'
        }) || ''

    const { variant: exploreVariant } = useVariant({
        experiment: 'explore_ct_desktop',
        cookieValue: 'explore_ct',
        experimentParameter: 'variant',
        defaultVariant: 'control',
    })

    const isExploreEnabled = isExploreFeatureEnabled(exploreVariant)

    const showRecentSearchWidget =
        !isServer() &&
        cysWidgetData?.desktop?.enabled &&
        isUserSignedIn() &&
        cysEnabledVariant?.toLowerCase() === 'yes'

    const showEliteBanner = !isServer() && loyaltyWidgetData?.desktop?.enabled

    const showUnifiedWidget = !isServer()

    function pushCleverTap(name: string) {
        Clevertap.event('Air_UI_Action', {
            action_type: 'Link',
            action_name: name
        })
    }

    const handleHomePageBannerClick = (url?: string) => {
        if (url) {
            pushCleverTap(ACTION_NAMES.bannerHomepageBBD)
            dispatcher(
                getActionPayload('NAVIGATE', {
                    type: NavigateType.IN_PAGE_REDIRECT,
                    url
                })
            )
        }
    }

    function setGdpr() {
        window && window.localStorage && window.localStorage.setItem('gdpr', 'true')
        setCookieBanner(false)
    }

    // async function getComplianceStatus() {
    //     try {
    //         const data = await getCompliancePolicyStatus()
    //         setShowComplianceBanner(!data?.isDisplayed)
    //     }
    //     catch(e) {
    //         console.log(e)
    //     }
    // }
  const saleData = SaleConfigObject['BlackFridaySale'] || {}
  const now = getIndianTime()
  const activeLogo = saleData.logos.find(item => now >= new Date(item.from) && now <= new Date(item.to))
  const logoUrl = activeLogo?.url || ''
  const showSaleHeroCopy = Boolean(activeLogo)
  const saleCustomStyle = saleData.logoMetrics?.cusomStyle ?? {}
  const saleLogoHeight = saleData.logoMetrics?.logoHeight
  const saleLogoWidth = saleData.logoMetrics?.logoWidth
  const bannerBackground = saleData.bannerBackground
    useEffect(() => {
        if (!isLoading && response) {   
            if (bannerData?.length) {
                bannerData.forEach((bannerGroup, groupIndex) => {
                    bannerGroup.banners.forEach((banner, bannerIndex) => {
                        ravenSDKHomeTrigger('a_merch_widget_impression', {
                            action_name: 'merch_impression',
                            object_id: 'static_banner',
                            src: banner?.src || 'n/a',
                            url: banner?.url ? `www.cleartrip.com${banner.url}` : 'n/a'
                        })
                    })
                })
            }
    
            if (!isEmpty(loginBannerData)) {
                ravenSDKHomeTrigger('a_merch_widget_impression', {
                    action_name: 'merch_impression',
                    object_id: 'app_banner',
                    src: loginBannerData?.[0]?.src || 'n/a',
                    url: loginBannerData?.[0]?.url ? `www.cleartrip.com${loginBannerData?.[0]?.url}` : 'n/a'
                })
            }

        }
    }, [isLoading])

    const staticBannerRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (isLoading  || !bannerData?.length) return

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
                    bannerData.forEach((bannerGroup, groupIndex) => {
                        bannerGroup.banners.forEach((banner, bannerIndex) => {
                            ravenSDKHomeTrigger('a_merch_widget_view', {
                                action_name: 'merch_view',
                                object_id: 'static_banner',
                                src: banner?.src || 'n/a',
                                url: banner?.url ? `www.cleartrip.com${banner.url}` : 'n/a'
                            })
                        })
                    })
                    observer.disconnect()
                }
            },
            {
                threshold: 0.1
            }
        )
        if (staticBannerRef.current) {
            observer.observe(staticBannerRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [isLoading])
     
    const loginBannerRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (isLoading || isEmpty(loginBannerData)) return

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
                    ravenSDKHomeTrigger('a_merch_widget_view', {
                        action_name: 'merch_view',
                        object_id: 'app_banner',
                        src: loginBannerData?.[0]?.src || 'n/a',
                        url: loginBannerData?.[0]?.url ? `www.cleartrip.com${loginBannerData?.[0]?.url}` : 'n/a'
                    })
                    observer.disconnect()
                }
            },
            {
                threshold: 0.1
            }
        )
        if (loginBannerRef.current) {
            observer.observe(loginBannerRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [isLoading])

    const handleBannerDataClick = (bannerGroup: any, groupIndex: number, bannerIndex: number) => {
        ravenSDKHomeTrigger('a_merch_widget_click', {
            action_name: 'merch_click',
            object_id: 'static_banner',
            url: bannerGroup?.banners[bannerIndex]?.url ? `www.cleartrip.com${bannerGroup?.banners[bannerIndex]?.url}` : 'n/a',
            src: bannerGroup?.banners[bannerIndex]?.src || 'n/a'
        })
    }

    const handleLoginBannerClick = (url: string, src: string) => {
        ravenSDKHomeTrigger('a_merch_widget_click', {
            action_name: 'merch_click',
            object_id: 'app_banner',
            url: url ? `www.cleartrip.com${url}` : 'n/a',
            src: src || 'n/a'
        })
    }
    const handleStaticBannerClick = (url: string | undefined, bannerGroup: any, groupIndex: number) => {
        if (!url) return;
        
        const bannerIndex = bannerGroup?.banners?.findIndex((banner: any) => banner.url === url)
        
        if (bannerIndex !== -1) {
            handleBannerDataClick(bannerGroup, groupIndex, bannerIndex)
        }
        
        handleHomePageBannerClick(url)
    }
    const handleUnlockEliteLoginClick = () => {
        dispatcher(getActionPayload('OPEN_MODAL', { type: ActionMapper.OPEN_LOG_IN_MODAL }))
    }
    const handleLoginBannerContainerClick = () => {
        const firstBanner = loginBannerData?.[0];

        if (firstBanner) {
            handleLoginBannerClick(firstBanner?.url || '', firstBanner?.src || '');
        }
    }
    return (
        <>
            {/* {showComplianceBanner && <ComplianceBanner setShowBanner={setShowComplianceBanner} />} */}
            <Container
                className="w-100p flex-1 pl-2 pr-2"
                onClick={setGdpr}
            >
                <Container marginLeft={'-8px'} marginRight={'-8px'}>
                    <Container className="col-19 pl-6 pr-6" style={{maxWidth:'1200px', margin:'auto'}}>
                        <Container className="row" marginLeft={'-8px'} marginRight={'-8px'} style={{flexWrap:"nowrap"}}>
                            <Container className="flex-1 pl-2 pr-2">
                                <Container className="bg-white mt-7">
                                    <div
                                        style={{
                                            borderRadius: '16px 16px 16px 0px',
                                            ...(logoUrl && bannerBackground
                                                ? { backgroundImage: bannerBackground }
                                                : {}),
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '96px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                position:'relative',
                                            }}
                                        >
                                            <div className="pt-4">
                                                {/* <h1 className="fs-9 c-neutral-900 fw-600" style={{ fontSize: '30px' }}>
                                                Biggest discounts on Flights
                                                </h1> */}
                                                <h1 className="fs-9 c-neutral-900 fw-600" style={{ fontSize: showSaleHeroCopy ? '32px' : '30px' }}>
                                                    {showSaleHeroCopy ? saleData?.header : 'Book Domestic & International Flight Tickets'}
                                                </h1>
                                                <div className="flex flex-middle mt-2" style={{ minHeight: '20px' }}>
                                                        <div className="flex flex-middle" style={{ minHeight: '20px' }}>
                                                                <h2 className="ml-1 c-neutral-900 fw-600" style={{ fontSize: showSaleHeroCopy ?'14px' : '18px' , fontWeight : showSaleHeroCopy ? '600' : '500' }}>
                                                                    {showSaleHeroCopy
                                                                        ? saleData?.subHeader
                                                                        : 'Enjoy hassle free flight ticket bookings at lowest airfare'}
                                                                </h2>
                                                        </div>
                                                </div>
                                            </div>  
                                            {logoUrl ? (
                                                <img
                                                    alt={saleData?.header}
                                                    className="p-absolute"
                                                    height={saleLogoHeight}
                                                    src={logoUrl}
                                                    style={saleCustomStyle}
                                                    width={saleLogoWidth}
                                                />
                                            ) : null}
                                        </div>
                                        <Container
                                            className="ba-solid bc-line-500 br-12 bg-neutral-100 p-relative z-20"
                                            css={{
                                                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.04)'
                                            }}
                                        >
                                            <HomeForm
                                                query={query}
                                                setQuery={handleQueryChange}
                                                setShowBanner={setShowBanner}
                                                setShowVisaBanner={setShowVisaBanner}
                                                isExploreEnabled={isExploreEnabled}
                                                offerConfigReady={offerHook}
                                            />
                                        </Container>
                                        <Container className="bg-white">
                                            { showVisaBanner && (
                                                <VisaDenialBanner isHomePage={true} />
                                            ) }
                                        </Container>
                                    </div>
                                    <ExpandWidgetAnimationWrapper
                                        WidgetComponent={
                                            showUnifiedWidget ? (
                                                <UnifiedWidgetStack
                                                    onLoginClick={handleUnlockEliteLoginClick}
                                                    abVariant={cysEnabledVariant}
                                                    showRecentSearch={showRecentSearchWidget}
                                                    showEliteBanner={showEliteBanner}
                                                />
                                            ) : (
                                                <></>
                                            )
                                        }
                                    >
                                    {/**
                                     * Added mb-4 class here to adjust the removal of recent search widget
                                     * TODO: @flightsTeam remove this class once we enable RecentSearch widget
                                     **/}
                                    {/**
                                     * Commenting this for now and will add as per requirements
                                     * TODO: @flightsTeam
                                     **/}
                                    {/* <Container className={'mt-10 c-pointer mb-4'} onClick={redirectToCfnrLandingPage}>
                  <Image src={cfnrHomeBannerUrl} alt={'cancel for no reason banner'} width={706} height={80} />
                {/* </Container> */}
                                    {showBanner && !showVisaBanner && (
                                        <ClearChoiceMaxBannerContainer isHomePage={true} />
                                    )}
                                    </ExpandWidgetAnimationWrapper>
                                </Container>
                            </Container>
                            <Container className="pl-2 pr-2" css={{ display: 'flex', flexDirection: 'column' }}>
                                <aside style={{width:'307px', display:'flex', flexDirection:'column', flex:1, marginLeft:'16px', marginTop:'28px'}}>
                                {!isLoading && (
                                        <>
                                            <CarousalOffer banners={carousalData} enabled={true} />
                                            <FlightDeals desktopCarousels={desktopCarousels!} searchParams={query} />
                                        </>
                                    )}
                                </aside>
                            </Container>
                        </Container>
                        {isExploreEnabled && <ExploreAnywhereMap departDate={query.depart_date} />}
                        {!isLoading && bannerData?.length ? (
                            bannerData.map((bannerGroup, groupIndex) => (
                                <Container key={groupIndex} className="pb-4">
                                    <Container className="bg-white p-relative w-100p pb-4">
                                        <Container className="c-pointer">
                                            <Container className="bg-white p-relative w-100p pt-8">
                                                <Container className=" pl-0 pr-0 c-pointer">
                                                    <Container ref={staticBannerRef}>
                                                        <ImageGrid
                                                            key={`desktopflightMultiHomePageBanner`}
                                                            handleClick={(url) => {
                                                                handleStaticBannerClick(url, bannerGroup, groupIndex)
                                                            }}
                                                            imageAlt="offer"
                                                            images={bannerGroup?.banners}
                                                            innerMargin={16}
                                                        />
                                                    </Container>
                                                </Container>
                                            </Container>
                                        </Container>
                                    </Container>
                                </Container>
                            ))
                        ) : (
                            <></>
                        )}
                        {!isEmpty(loginBannerData) && (
                            <div 
                                ref={loginBannerRef} 
                                className="p-relative"
                                onClick={() => handleLoginBannerContainerClick()}
                            >
                                <Spacer className="pt-12" />
                                <a href="https://cleartrip.app.link/4ZfNFjig9vb">
                                    <div className="p-absolute btn-android" />
                                </a>
                                <a href="https://cleartrip.app.link/uy7d0Aauhwb">
                                    <div className="p-absolute btn-ios" />
                                </a>
                                <div>
                                    <ImageGrid
                                        handleClick={handleHomePageBannerClick}
                                        images={loginBannerData!}
                                        innerMargin={16}
                                    />
                                </div>
                            </div>
                        )}
                        {!isEmpty(fkResponseImages) && (
                            <div className="mt-12 c-pointer">
                                <FkImages fkResponseImages={fkResponseImages} />
                            </div>
                        )}
                        <Spacer className="pt-12" />
                        <TripSuggestor isHomePage={true} />
                        <FAQs />
                    </Container>
                </Container>
                <CookieBanner cookieBanner={cookieBannerFlag} onClick={setGdpr} />
            </Container>
        </>
    )
}

export default withErrorBoundary(HomeMain, {
    boundary: 'home-main',
    page: 'home',
    isPageLevel: true,
    fallbackRender: ({ resetErrorBoundary }) => (
        <InlineSectionErrorFallback
            title="Something went wrong on the homepage"
            onRetry={resetErrorBoundary}
        />
    ),
})
